<template>
        <div id='withdraw'>
              <NavTop title='提现'/>
              <div class='content'>
                  <div class="row">
                     <div class="label">会员真实姓名</div>
                     <div class="maininput">{{info.realname}}</div>
                  </div>
                  <div class="row">
                     <div class="label">已绑定银行卡</div>
                     <div class="maininput">{{info.bankcard}}</div>
                  </div>
                  <div class="row">
                     <div class="label">可提现总积分</div>
                     <div class="maininput">{{info.total}}</div>
                  </div>
                  <div class="row">
                     <div class="label">申请提现积分</div>
                     <div class="maininput"><input placeholder="请输入申请提现的积分" type="number" v-model="points"/></div>
                  </div>
                  <div class="row">
                     <div class="label">短信验证码</div>
                     <div class="maininput"><input placeholder="请输入验证码" type='number' v-model="code"/></div>
                     <div class="yzm_btn" @click="getCode(5)">获取验证码</div>
                   </div>
                   <div class="submitbtn_out">
                     <div class="submitbtn" @click="onSubmit">提交</div>
                   </div>
                   <div class="tiprow">
                     <div>1、提现方式：当前仅限提现到已绑定的银行卡。</div>
                     <div>2、提现规则：单笔最低提现额度：100积分；提现手续费为6%，在提现积分里自动扣除（示例：提现1000，到账940）。</div>
                     <div>3、提现时间：周一至周五，每天9点-18点，每日可申请提现次数最多为1次。</div>
                     <div>4、到账时间：采用T+3的模式，非工作日顺延。（非工作日指：周六、周日、法定节假日、公司指定日期）</div>
                   </div>
              </div>        
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import {Icon,Dialog} from 'vant';

export default {
  name: 'withdraw',
  data(){
      return{
         info:{},
         points:'',
         mobile:'',
         code:'',
         processing:false
      }
  },  
  created(){
      this.getList()
  },
  methods:{
     getList(){
         this.$post("/user/getUserInfo",{}).then((data)=>{
            if(data.result.success){
               if(data.result.info.realname==null || data.result.info.realname==''){
                  Dialog.confirm({
                     title: '温馨提醒',
                     message: '您的姓名还未设置，请设置完姓名后再来提现',
                     })
                     .then(() => {
                         this.$go("/myprofile")
                     })
                     .catch(() => {
                         this.$go("/points")
                     });
               }else if(data.result.info.bankcard==null || data.result.info.bankcard==''){
                    Dialog.confirm({
                     title: '温馨提醒',
                     message: '您的银行卡还未绑定，请绑定完银行卡后再来提现',
                     })
                     .then(() => {
                         this.$go("/bindcard")
                     })
                     .catch(() => {
                         this.$go("/points")
                     });
               }else{
                   this.$post("/prize/getWithDrawInfo",{}).then((data)=>{
                      if(data.result.success){
                         this.info=data.result.info
                         this.mobile=data.result.info.mobile
                      }else{
                         this.$toast(data.result.info)
                      }
                   })
               }
            }else{
               this.$toast(data.result.info)
            }
         })
      },
      onSubmit(){
         if(this.processing){
            this.$toast("请等待提交完成")
            return false
         }
         if(this.info.total<=0){
            this.$toast("可提现积分为0，无法申请")
            return false
         }
         if(this.code==""|| isNaN(this.code)){
            this.$toast("验证码不能为空")
            return false
         }
         if(this.points<100 || this.points<=0 || isNaN(this.points)){
            this.$toast("提现积分最小值100")
            return false
         }
         this.processing=true
         this.$post("/prize/addPrizeRequest",{points:this.points,code:this.code}).then((data)=>{
             this.processing=false
             if(data.result.success){
                 this.$toast(data.result.info)
                 setTimeout(()=>{this.$go("/my")},1000)
             }else{
                 this.$toast(data.result.info)
             }
         })
      },
      getCode(type){
         if(this.mobile==''|| isNaN(this.mobile)){
            this.$toast("手机号码不正确")
            return false
         } 
         this.$post("/sms/getCode",{mobile:this.mobile,type:type}).then((data)=>{
              this.$toast(data.result.info)
         })
     }
  },
  components:{
      NavTop,
      [Icon.name]:Icon,
      [Dialog.Component.name]: Dialog.Component
  }
}
</script>
<style scoped>
#withdraw{background-color:#F6F6F6;min-height: 100vh;}
.content{border-radius: 0.2rem;background-color: #fff;display: flex;flex-flow: column nowrap;margin: 0.3rem;}
.row{padding: 0.4rem;display: flex;border-bottom: 1px solid #e7e7e7;}
.label{text-align: left;width:2.5rem;font-size:0.35rem;color:#333;}
.maininput{flex:1 0 auto;text-align: left;}
.maininput input{text-align: left;font-size:0.35rem;color:#333;width:100%;}
.submitbtn{background-color:#ee0a24;color:#fff;;font-size:0.35rem;padding: 0.25rem;border-radius: 0.1rem;}
.tiprow{font-size:0.3rem;background-color: #F6F6F6;padding: 0.3rem;text-align: left;}
.tiprow-icon{display: flex;align-items: center;margin-right: 0.1rem;}
.tiprow-icon img{width:0.3rem;height:0.3rem;}
::v-deep .van-cell__title{text-align: left;}
.banktitle{font-size:0.42rem;padding: 0.2rem;}
.bankcon{display: flex;flex-flow: row nowrap;align-items: center;}
.bankicon{width:1.0rem;height:1.0rem;}
.banklabel{font-size:0.35rem;padding: 0.15rem;}
.bankshowcon{display: flex;align-items: center;flex-flow: row nowrap;padding: 0.35rem;}
.bankshowcon-left img{width:1.2rem;height:1.2rem;}
.bankshowcon-right{display: flex;flex-flow: column nowrap;text-align: left;padding-left: 0.3rem;}
.yzm_btn{text-decoration: underline;font-size:0.3rem;color:#333;}
</style>


